import React from 'react';
import ScrollToTop from "react-scroll-to-top";

function Footer() {
  return (
    <footer className='site-footer'>
        <ScrollToTop smooth />
      <div className="custom-container">
        <span className='copyright'>
          ©2023 | <a href="#profile" className='link-text'>Jitendra Sharma</a>. All rights reserved.
        </span>
      </div>
    </footer>
  );
}

export default Footer;